import { Typography } from '@mui/material'
import { Box } from '@mui/system'
import React from 'react'
import UseTranslation from '../../../../hooks/UseTranslation'

function StepThree({ language, count }) {
  const { t } = UseTranslation()
  return (
        <Box sx={styles.root}>
            <Typography>
        {t?.['Are you sure you want to Create']} <Typography component={'span'} sx={styles.count}> {count} </Typography>
        {t?.['Users for the employees in your Company with Language']}
        <Typography component={'span'} sx={styles.language}> {language?.name} </Typography>

         {t?.EnLanguage}.
            </Typography>
            <Typography>{t?.['Once Confirmed, You can’t undo this action anymore.']}</Typography>
        </Box>
  )
}
const styles = {
  root: {
    display: 'flex',
    flexDirection: 'column',
    gap: '20px',
    padding: { xs: '10px 5px 50px', sm: '20px' },
  },
  count: { color: '#29CC8B', fontWeight: 'bold' },
  language: { fontWeight: 'bold' },

}

export default StepThree
